<template>
    <div class="register">
        <div class="register-box">
            <div class="register-logo">
                <img src="/logo.png" alt="Logo" class="img-circle">
                <br/>
                <span style="font-family: 'Khmer MEF2'"> យានយន្តចេញចូលបណ្តោះអាសន្ន</span>
                <br/>
                <span>Temporary Entry and Exit of Vehicles</span>
            </div>

            <div class="card card-success card-outline">
                <div class="card-body register-card-body">
                    <div class="alert alert-danger" v-if="user.errors.length > 0">
                        <p class="mb-0"><strong>Whoops!</strong> Something went wrong!</p>
                        <ul>
                            <li v-for="(error, index) in user.errors" :key="index">
                                {{ error }}
                            </li>
                        </ul>
                    </div>
                    <form @submit.prevent="handleSubmit">
                        <div class="row">
                            <div class="form-group has-feedback col-md-6">
                                <input v-model="user.first_name" type="text" name="firstname" class="form-control" :placeholder="$t('label.first_name') + ' *'" :class="{ 'is-invalid': submitted && !user.firstname }">
                            </div>
                            <div class="form-group has-feedback col-md-6">
                                <input v-model="user.last_name" type="text" name="lastname" class="form-control" :placeholder="$t('label.last_name') + ' *'" :class="{ 'is-invalid': submitted && !user.lastname }">
                            </div>
                            <div class="form-group has-feedback col-md-12">
                                <input v-model="user.email" type="email" name="email" class="form-control" :placeholder="$t('label.email') + ' *'" :class="{ 'is-invalid': submitted && !user.email }">
                            </div>
                            <!-- gender -->
                            <div class="form-group has-feedback col-md-6">
                                <select class="form-control" v-model="user.gender">
                                    <option value="" disabled>{{$t('label.gender')}} *</option>
                                    <option value="m">{{$t('label.male')}}</option>
                                    <option value="f">{{$t('label.female')}}</option>
                                </select>
                            </div>
                            <!-- phone -->
                            <div class="form-group has-feedback col-md-6">
                                <input v-model="user.phone" type="text" name="phone" class="form-control" :placeholder="$t('label.phone') + ' *'" :class="{ 'is-invalid': submitted && !user.phone }">
                            </div>
                            <!-- city -->
                            <div class="form-group has-feedback col-md-6">
                                <input v-model="user.city" type="text" name="phone" class="form-control" :placeholder="$t('label.city')">
                            </div>
                            <!-- zip -->
                            <div class="form-group has-feedback col-md-6">
                                <input v-model="user.zip" type="number" name="zip" class="form-control" :placeholder="$t('label.zip')" >
                            </div>
                            <!-- Address -->
                            <div class="form-group has-feedback col-md-12">
                                <input v-model="user.address" type="text" name="address" class="form-control" :placeholder="$t('label.address')">
                            </div>
                            <!-- password -->
                            <div class="form-group has-feedback col-md-6">
                                <input v-model="user.password" type="password" name="password" class="form-control" :placeholder="$t('label.password') + ' *'" :class="{ 'is-invalid': submitted && !user.password }">
                            </div>
                            <!-- confirm password -->
                            <div class="form-group has-feedback col-md-6">
                                <input v-model="user.password_confirmation" type="password" name="confirm_password" class="form-control" :placeholder="$t('label.confirm_password') + ' *'" :class="{ 'is-invalid': submitted && !user.confirm_password }">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 offset-md-4">
                                <button type="submit" class="btn btn-primary btn-block">{{$t('label.register')}}</button>
                            </div>
                        </div>
                    </form>
                    <p class="mb-1 text-center">
                        <br>
                        <router-link to="/login">
                            {{$t('label.back')}}
                        </router-link>
                    </p>
                </div>
            </div>
            <link-locale-changer/>
        </div>
    </div>
</template>

<script>
var _ = require('lodash');
export default {
    name: "Register",
    data() {
        return {
            user: {
                first_name: "",
                last_name: "",
                gender: "",
                email: "",
                address: "",
                phone: "",
                password: "",
                errors: [],
                zip:""                    
            },
            MY_URL:"",
            submitted: false,
        };
    },
    watch: {
        "user.zip": function(val, old){
            if(val.length>5){
                this.user.zip = old;
            }
        }
    },
    mounted() {
        this.MY_URL =  process.env.VUE_APP_BACKEND_API_URL;        
    },
    methods: {
        handleSubmit() {
            this.$store.state.loading.status = true;
            axios.post(this.MY_URL+'/frontend/register', this.user)
                .then(response => {
                    if(response){
                        this.$router.push({ path: 'home' })
                    }
                    this.$store.state.loading.status = false;
                })
                .catch(error => {
                    if (typeof error.response.data === 'object') {
                        this.user.errors = [];
                        this.user.errors = _.flatten(_.toArray(error.response.data.errors));
                    } else {
                        this.user.errors = ['Something went wrong. Please try again.'];
                    }
                    this.$store.state.loading.status = false;
                });
        },
    }
};
</script>